import * as types from '../mutation-types';
import {unionState} from '../helpers';

const state = () => ({
	sliderImages: [],
});

const actions = {
    fetchAll({commit}) {
		return axios.get('/api/slider-images').then(response => {
			commit(types.STORE_SLIDER, response.data);

			return response.data;
		});
	},

	fetch({commit}, {sliderImageId}) {
		return axios.get(`/api/slider-images/${sliderImageId}`).then(response => {
			commit(types.STORE_ONE_SLIDER, response.data);

			return response.data;
		});
	},

	create({commit}, {images}) {
		const formData = new FormData();
		for (let image of images)
			formData.append('images[]', image);
	
		return axios.post('/api/slider-images', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			commit(types.STORE_ONE_SLIDER, response.data);

			return response.data;
		});
	},

	update({commit}, {sliderImageId, image}) {
		const formData = new FormData();
		formData.append('image', image);

		formData.append('_method', 'PUT');
	
		return axios.post(`/api/slider-images/${sliderImageId}`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			commit(types.STORE_ONE_SLIDER, response.data);

			return response.data;
		});
	},

	delete({commit}, {id}) {
		return axios.delete(`/api/slider-images/${id}`).then(() => {
			commit(types.DELETE_SLIDER, id);
		});
	}
};

const mutations = {
	[types.STORE_SLIDER](state, images) {
		state.sliderImages = unionState(state.sliderImages, images);
	},

	[types.STORE_ONE_SLIDER](state, image) {
		state.sliderImages = unionState(state.sliderImages, [image]);
	},

	[types.DELETE_SLIDER](state, id) {
		state.sliderImages = state.sliderImages.filter(t => t.id !== id);
	},
};

const getters = {
	getById: state => id => state.restaurants.find(t => t.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};